import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchExtracharges,
  SearchExtrachargesVariables
} from "./types/SearchExtracharges";

export const searchExtracharges = gql`
  ${pageInfoFragment}
  query SearchExtracharges($after: String, $first: Int!, $query: String!) {
    search: productSkuExtraCharge(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          categoryName
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchExtracharges,
  SearchExtrachargesVariables
>(searchExtracharges);
